import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import TestimonialImage from "../../../../../assets/images/png/courses/course-testimonial.webp";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/trainers pictures/PRINCEWILL SUIT - AI Automation Practice Lead.png";
import OmobosolaImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/OMOBOSOLA SUIT - Product & Digital Marketing and AI Automation Support Person.png";
import RachaelImage from "../../../../../assets/images/png/courses/instructors/rachael.webp";
import DoluImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/Ayotunde1.webp";
import FaithImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/FAITH Customer Success Manager.png";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/product.webp";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import FullStackPreview from "../../../../../assets/images/jpeg/softwarePreview.jpeg";

export const fullstackProgrammingAfrica = {
  id: 1,
  tag: "FOR EARLY STARTERS",
  title: "Fullstack Development",
  seoTitle: "Fullstack Development",
  description: `
  This course is designed to take you from absolute beginner to competent 
  full-stack web developer in a matter of weeks. It is a practical course 
  where you will start building real websites from the first lecture. Application 
  will consist of the frontend and backend parts. The practical full stack web 
  development bootcamp includes: JavaScript, React, HTML, CSS, Node.js.
    `,
  duration: "4 Months",
  downloadBrochureUrl:
    "https://drive.google.com/file/d/1D8_gSKzi06-J-57-TaMzRkgpSCg24r5f/view?usp=sharing",

  courseFormUrl: "courses/fullstack-development/fill-form",

  jobTitle: "Software Developer",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Friday 4:00 PM - 7:00 PM WAT
      <br />
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    image: TestimonialImage,
    name: "Monica A.",
    role: "Fullstack Developer",
    testimony: `
    I was looking for something a little more than a training, a school I 
    could count on for my continuous skill and professional development. Utiva became my new home and
    now I can boldly say that I am a Fullstack developer.`,
    starRating: "5.0",
  },

  courseOverview: {
    title: `Learn Full-Stack Web Development Live, Led by Experienced 
    Software Engineers and move on to New Roles in Tech`,
    desc: `
    Become a full stack web developer with just one course. In 6 months  you’ll learn all you need to know to become a 
    Frontend Developer by learning the fundmentals of HTML, CSS, JavaScript, React, NodeJS, ExpressJS and more!
    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Web Development Fundamentals",
      unitTag: "HTML, CSS, Flexbox",
      unitDescription: `
      Learn to structure code in a concise, logical, and readable manner, 
      while mastering HTML and CSS, two foundational front-end languages. 
      Create static web pages using HTML and CSS alone, before applying Flexbox (a CSS framework) 
      to increase the complexity and speed in which you create your web pages.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Software Development Fundamentals",
          featureDescription: `An introductory session that develops you on the
          fundamentals software engineering principles
          .`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Fundamentals of User Interface",
          featureDescription: `This class is a UI session on product design, high fidelity mockups and interaction design.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Markup & Styling",
          featureDescription: `Get started with HTML for Markup and CSS for styling.
          Learn the Flexbox Model and Bootstrap Framework.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Rudiments of JavaScript",
          featureDescription: `Introduction to Javascript Syntax Conditionals, Arrays, Objects, Loops. DOM. 
          You will also learn the tools of the business like Browser Dev Tools, Command line, IDE.  
          Vs-Code, Working with Terminals. Git, Advance Git, Github plus Javascripts fundamental like API & JSON.`,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "JavaScript",
      unitTag: "Functions, Animations, Components",
      unitDescription: `
      Sites today don’t just display content – they are interactive, with animations, 
      logins, checkouts, and much more. To add functionality to your websites, 
      you will learn the essentials of object-oriented 
      programming and JavaScript, including how to leverage reusable "building blocks" of code.
      You will then build on these programming fundamentals by learning how to create and implement functions and animations.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Learning",
          featureDescription: `Use your new skills to create a professional website that is responsive 
              to both mobile and computer browsers. Your work will be expanded later in the program.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Fundamentals",
          featureDescription: `You will augment your previously developed static site by adding 
              multiple pages with underlying logic to create basic interactive features.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "React",
          featureDescription: `Using React, you’ll create a professional single page application, 
              which leverages complex functionality and visual styling.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "API",
          featureDescription: `You’ll create your own API to add further functionality to front-end applications.`,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "React",
      unitTag: "Components, States, APIs",
      unitDescription: `
      Leverage React, one of the most popular JavaScript frameworks, 
      to refine the quality of your work and create professional user interfaces. 
      You’ll learn to manage states, allowing your website to work with data 
      in a more dynamic way; and integrate an application programming 
      interface (API), which connects your website to a back-end.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Learning",
          featureDescription: `Use your new skills to create a professional website that is responsive 
          to both mobile and computer browsers. Your work will be expanded later in the program.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Fundamentals",
          featureDescription: `You will augment your previously developed static site by adding 
          multiple pages with underlying logic to create basic interactive features.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "React",
          featureDescription: `Using React, you’ll create a professional single page application, 
          which leverages complex functionality and visual styling.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "API",
          featureDescription: `You’ll create your own API to add further functionality to front-end applications.`,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Node",
      unitTag: "Express, Clients",
      unitDescription: `
      Learn how websites interact with a back-end to exchange application data. 
      Using Node.js, a JavaScript environment, and Express, a Node framework, 
      you’ll learn how to quickly leverage back-end technologies to create a 
      full-stack application. By understanding how to create your own application 
      programming interface (API), you’ll be able to customize and improve the functionality of your work.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Learning",
          featureDescription: `Use your new skills to create a professional website that is responsive 
          to both mobile and computer browsers. Your work will be expanded later in the program.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Fundamentals",
          featureDescription: `You will augment your previously developed static site by adding 
          multiple pages with underlying logic to create basic interactive features.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "React",
          featureDescription: `Using React, you’ll create a professional single page application, 
          which leverages complex functionality and visual styling.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "API",
          featureDescription: `You’ll create your own API to add further functionality to front-end applications.`,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle: "Agile Development",
      unitTag: "Git, Pair Programming, Jira",
      unitDescription: `
      Understanding how to collaborate with other developers and work on agile 
      teams is a critical skill for all developers. Learn to jointly 
      work on an agile project with other developers, 
      using git to manage versions and share work. 
      You’ll be assigned tasks and use Jira to manage the development process.
            `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Tools of the Business",
          featureDescription: `
          You will learn the tools of the business like Browser Dev Tools, Command line, IDE.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Frontend Development",
          featureDescription: `Learn the advanced frontend
          development tech tool - React.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Backend Development",
          featureDescription: `Develop your JavaScript skills with the NodeJS tool and
          ExpressJS framework.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Problem Solving",
          featureDescription: `Learn to use Debugging Methodologies, master how to searching Algorithms and use the
          Chrome Developer Tools.
          `,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "Databases",
      unitTag: "MySQL, Database Structures",
      unitDescription: `
        Understanding different database structures is critical in 
        managing large amounts of information in an efficient and effective way. 
        To store and manage data, you’ll learn how to use MySQL, a high-performance, 
        open-source relational database management system used by data-rich companies like YouTube, Netflix, and Spotify.
              `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Research",
          featureDescription: `Conduct user research for a particular problem space, including interviewing 
                    potential users. Build research-backed personas to guide the design process.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Structuring",
          featureDescription: `With your personas in mind, begin to structure requirements 
                    into a well-defined organizational scheme using techniques such as card sorting.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Translation",
          featureDescription: `Begin translating your solution from black and white paper sketches, into 
                    high-fidelity designs and test your designs to get feedback and iterate throughout the process.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Prototyping",
          featureDescription: `Translate sketches into clickable prototypes using InVision. 
                      Continue to test and refine designs before reaching a final prototype ready to be developed.`,
        },
      ],
    },
    {
      unitId: 7,
      unitTitle: "Professional Development",
      unitTag: "Deployment, Authentication, Portfolios",
      unitDescription: `
        With a solidified understanding of how to build out web 
        applications, you’ll learn how to deploy your work so that 
        it can be viewed online. You’ll also be introduced to topics 
        such as security, authentication methods, and additional web 
        frameworks to continue to expand your understanding of development.
              `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Research",
          featureDescription: `Conduct user research for a particular problem space, including interviewing 
                    potential users. Build research-backed personas to guide the design process.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Structuring",
          featureDescription: `With your personas in mind, begin to structure requirements 
                    into a well-defined organizational scheme using techniques such as card sorting.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Translation",
          featureDescription: `Begin translating your solution from black and white paper sketches, into 
                    high-fidelity designs and test your designs to get feedback and iterate throughout the process.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Prototyping",
          featureDescription: `Translate sketches into clickable prototypes using InVision. 
                      Continue to test and refine designs before reaching a final prototype ready to be developed.`,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Princewill Ogbu",
      coachRole: "AI Automation Practice Lead",
    },
    {
      coachId: 2,
      coachImage: RachaelImage,
      coachName: "Rachael Wilson",
      coachRole: "Senior Data Analyst",
    },
    {
      coachId: 3,
      coachImage: DoluImage,
      coachName: "Doluwamu Ayotunde Solana",
      coachRole: "Senior Data Scientist",
    },
    {
      coachId: 4,
      coachImage: FaithImage,
      coachName: "Faith",
      coachRole: "Customer Success Manager",
    },
    {
      coachId: 5,
      coachImage: OmobosolaImage,
      coachName: "Omobosola Olafimihan",
      coachRole: "AI Automation Support",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Learning Model",
      modelDescription:
        "A 3 Weeks experiential learning and hands-on training session.",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Training Methodology",
      modelDescription: "Learn through real-life problems",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Business Case-Focused",
      modelDescription:
        "Work on real-life projects by applying what you learn to solve related business problems.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Access Contents & Materials",
      modelDescription: "50% on your own + 50% in live classes",
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "",
      image: null,
      firstname: "Abayomi",
      lastname: "O.",
      company: "Frontend Dev Fellow",
      testimony: `
      Utiva has impacted my career progression in a 
      positive way as the changes in the last couple of months have 
      been rapid. I've had to change roles from a business-oriented role 
      to a digital-oriented role. I've had opportunities to implement 
      my learnings in real life scenarios, had a role change to a developer role, scholarships 
      and also volunteering roles. I feel fulfilled implementing my passion.  
      `,
    },
  ],

  portofolio: {
    title: "Build Solutions around Real-life Business Cases ",
    description: `
    Present everything you've learned with a real-world capstone project. 
    Every week in your fullstack web development classes, you'll be provided 
    with clear actionable steps to iteratively develop your project. 
    By the end of the course, you will have implemented each step of 
    the data analysis process, leveraging your knowledge of PostgreSQL and data visualization tools 
    to develop and derive a comprehensive solution of your work.
      `,
    name: "Olatunji Abayomi",
    // image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Fullstack Web Development Certification",
    description: `
    Upon completing Utiva's Fullstack Web Development Course, you'll 
    receive an industry-recognized, professional Fullstack Web Development
    certification to share with your network and showcase all that 
    you've learned. Utiva certificates are formatted for sharing on LinkedIn.
      `,
  },

  // videoTestimonial: "https://youtu.be/TQrD6jyYqxs",
  videoTestimonial: "https://www.youtube.com/embed/ArxnT-7wAg4",
  videoPreviewImage: FullStackPreview,

  otherCourses: [
    {
      id: 1,
      courseTitle: "Become a Frontend Developer",
      courseDescription: `You’ll learn all you need to know and build the capacity to 
      handle projects with an interesting portfolio as a frontend developer with a 
      coaching program that focuses on fundamentals of HTML, CSS, JavaScript and React.`,
      courseUrl: "/courses/frontend-development",
    },
    {
      id: 2,
      courseTitle: "Become a Backend Developer",
      courseDescription: `Go from zero knowledge to being able to build your own complete 
      websites! Starting with the foundations of software engineering. 
      Develop and deploy enterprise back-end applications following best practices using Express JS & NodeJS.`,
      courseUrl: "/courses/backend-development",
    },
  ],
};
